import NoteIcon24 from "@/assets/SVG/noteIcon24";
import { Box, Collapse, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  getActiveAreaId,
  getModuleNameInArea,
  getModulesInTab,
} from "../../api/area";
import { getStaticAccesses, myAccesses } from "../../api/jahadgar";
import DashboardIcon from "../../assets/SVG/dashboard";
import { OptionsSidebar } from "../sidebar/sidebar";

export default function SidebarAreaManager() {
  const [select, setSelect] = useState(0);
  const [moduleData, setModuleData] = useState();
  const [moduleName, setModuleName] = useState();
  const [tabNameData, setTabNameData] = useState();
  const [jahadgarRoute, setJahadgarRoute] = useState();
  const [drugLevel, setDrugLevel] = useState();
  const [equimpLevel, setEquimpLevel] = useState();
  const [referralLevel, setReferralLevel] = useState();
  const [reportAccess, setReportAccess] = useState();
  const [areaId, setAreaId] = useState();

  useEffect(() => {
    getActiveAreaId().then((res) => {
      setAreaId(res);
    });
  }, []);

  useEffect(() => {
    let hasFetchTabs = false;
    let hasFetchStaticAccesses = false;

    if (areaId) {
      let areaData = undefined;

      if (localStorage.getItem("area_data_" + areaId) !== null) {
        const tmp = JSON.parse(localStorage.getItem("area_data_" + areaId));
        if (tmp.expire_at > Date.now()) {
          areaData = tmp;
          if (areaData?.tabs) {
            setModuleData(areaData.tabs);
            hasFetchTabs = true;
          }
          if (areaData?.static_accesses) {
            setJahadgarRoute(areaData.static_accesses);
            hasFetchStaticAccesses = true;
          }
        }
      }

      if (hasFetchStaticAccesses && hasFetchTabs) return;
      if (areaData === undefined) {
        areaData = {
          expire_at: Date.now() + 86400000,
        };
      } else {
        localStorage.removeItem("area_data_" + areaId);
      }

      Promise.all(
        !hasFetchTabs && !hasFetchStaticAccesses
          ? [getStaticAccesses(areaId), getModuleNameInArea(areaId)]
          : !hasFetchTabs
            ? [getModuleNameInArea(areaId)]
            : [getStaticAccesses(areaId)],
      ).then((res) => {
        if (!hasFetchTabs && !hasFetchStaticAccesses) {
          setJahadgarRoute(res[0]);
          setModuleData(res[1]);
          areaData.static_accesses = res[0];
          areaData.tabs = res[1];
        } else if (!hasFetchTabs) {
          setModuleData(res[0]);
          areaData.tabs = res[0];
        } else {
          setJahadgarRoute(res[0]);
          areaData.static_accesses = res[0];
        }
        localStorage.setItem("area_data_" + areaId, JSON.stringify(areaData));
      });
    }
  }, [areaId]);

  useEffect(() => {
    if (areaId && moduleName && moduleName !== null && moduleName !== "null")
      getModulesInTab(areaId, moduleName)
        .then((z) => setTabNameData(z))
        .catch(() => {});
  }, [areaId, moduleName]);

  useEffect(() => {
    if (localStorage.getItem("my_accesses") !== null) {
      const accesses = JSON.parse(localStorage.getItem("my_accesses"));
      setDrugLevel(accesses?.drug_access || false);
      setEquimpLevel(accesses?.equipment_access || false);
      setReferralLevel(accesses?.referral_access || false);
      setReportAccess(accesses?.report_access || false);
      return;
    }
    Promise.all([myAccesses()]).then((res) => {
      setDrugLevel(res[0].drugAccess);
      setEquimpLevel(res[0].equipmentAccess);
      setReferralLevel(res[0].externalReferralAccess);
      setReportAccess(res[0].reportAccess);
      localStorage.setItem(
        "my_accesses",
        JSON.stringify({
          drug_access: res[0].drugAccess,
          equipment_access: res[0].equipmentAccess,
          referral_access: res[0].externalReferralAccess,
          report_access: res[0].reportAccess,
        }),
      );
    });
  }, []);

  const handleModuleClick = (name) => {
    // اگر ماژول فعلی همان ماژولی است که کلیک شده، آن را ببند (null تنظیم کن)
    // در غیر این صورت، ماژول جدید را باز کن
    setModuleName(moduleName === name ? null : name);
  };

  if (moduleData) {
    return (
      <Grid display={"flex"} flexDirection={"column"} mt={"50px"}>
        <Typography mb={"10px"} color={"text.primary"}>
          ابزار
        </Typography>
        <OptionsSidebar
          href="/"
          onClick={() => setSelect(0)}
          select={select === 0}
          text="داشبورد"
          icon={<DashboardIcon color={"white"} />}
        />
        <OptionsSidebar
          href="/notes"
          select={window.location.pathname === "/notes"}
          text="یادداشت‌ها"
          icon={<NoteIcon24 width={24} color={"white"} />}
        />
        {jahadgarRoute?.dispatcher &&
          Object.entries(moduleData)?.length > 0 && (
            <OptionsSidebar
              href="/reception"
              onClick={() => setSelect(105)}
              select={select === 105}
              text="پذیرش"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-reception-2-1"}
                  color={"var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
          )}
        {jahadgarRoute?.trainer && Object.entries(moduleData)?.length > 0 && (
          <>
            <OptionsSidebar
              arrowIcon
              onClick={() => {
                handleModuleClick("آموزش");
              }}
              select={moduleName === "آموزش"}
              text="آموزش"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"my-menu-icon icon-classroom-1"}
                  color={"var(--emr-disable)"}
                  fontSize="20px"
                />
              }
            />
            {[
              { moduleName: "آموزش بزرگسال", href: "/education" },
              { moduleName: "آموزش کودکان", href: "/childrenEducation" },
            ].map((x, index) => (
              <Collapse
                key={index}
                sx={{ px: "20px" }}
                in={moduleName === "آموزش" ? true : false}
                timeout="auto"
              >
                <OptionsSidebar
                  href={x.href}
                  onClick={() => setSelect(index + 1)}
                  select={select === index + 1}
                  text={x.moduleName}
                  icon={<DashboardIcon color={"white"} />}
                />
              </Collapse>
            ))}
          </>
        )}
        {jahadgarRoute?.insurance && Object.entries(moduleData)?.length > 0 && (
          <OptionsSidebar
            href="/insurer"
            onClick={() => setSelect(103)}
            select={select === 103}
            text="بیمه گر"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-insurance-1"}
                color={"var(--emr-disable)"}
                fontSize="20px"
              />
            }
          />
        )}
        {moduleData &&
          Object.entries(moduleData)?.map((x, i) => (
            <Grid key={i}>
              <OptionsSidebar
                arrowIcon
                onClick={() => {
                  handleModuleClick(x[0]);
                }}
                select={moduleName === x[0] ? false : true}
                text={x[0]}
                icon={
                  <Box
                    sx={{
                      fontFamily: "icomoon !important",
                      cursor: "pointer",
                    }}
                    className={`my-menu-icon ${x[1]}`}
                    color={"var(--emr-disable)"}
                    fontSize="20px"
                  />
                }
              />
              {tabNameData?.map((z, index) => (
                <Collapse
                  key={index}
                  sx={{ px: "20px", cursor: "pointer" }}
                  in={moduleName === x[0] ? true : false}
                  timeout="auto"
                >
                  <OptionsSidebar
                    href={
                      z.moduleName === "پذیرش"
                        ? "reception"
                        : x.moduleName === "آموزش بزرگسالان"
                          ? "education"
                          : x.moduleName === "آموزش کودکان"
                            ? "childrenEducation"
                            : x.moduleName === "بیمه گر"
                              ? "insurer"
                              : `module?${z.moduleId}?${moduleName}`
                    }
                    onClick={() => setSelect(index + 1)}
                    select={select === index + 1}
                    text={z.moduleName}
                    icon={<DashboardIcon color={"white"} />}
                  />
                </Collapse>
              ))}
            </Grid>
          ))}
        {jahadgarRoute?.pharmacy && Object.entries(moduleData)?.length > 0 && (
          <OptionsSidebar
            href="/drugTable"
            onClick={() => setSelect(200)}
            select={select === 200}
            text="داروخانه"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-pharmacy"}
                color={"white"}
                fontSize="20px"
              />
            }
          />
        )}
        {jahadgarRoute?.equipment && Object.entries(moduleData)?.length > 0 && (
          <OptionsSidebar
            href="/area-equipments"
            onClick={() => setSelect(201)}
            select={select === 201}
            text="انبار تجهیزات"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-warehouse-1-1"}
                color={"white"}
                fontSize="20px"
              />
            }
          />
        )}
        {jahadgarRoute?.pharmacy && Object.entries(moduleData)?.length > 0 && (
          <OptionsSidebar
            href={`/area-drugs`}
            onClick={() => setSelect(202)}
            select={select === 202}
            text="انبار داروخانه"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-warehouse-1-1"}
                color={"white"}
                fontSize="20px"
              />
            }
          />
        )}
        {drugLevel && (
          <>
            <OptionsSidebar
              href="/drugWarehouse"
              onClick={() => setSelect(300)}
              select={select === 300}
              text="داروخانه"
              icon={
                <Box
                  sx={{ fontFamily: "icomoon !important " }}
                  className={"icon-pharmacy"}
                  color={"white"}
                  fontSize="20px"
                />
              }
            />
          </>
        )}

        {referralLevel && (
          <OptionsSidebar
            href="/erjaTable"
            onClick={() => setSelect(220)}
            select={select === 220}
            text="ارجاعات"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-warehouse-1-1"}
                color={"white"}
                fontSize="20px"
              />
            }
          />
        )}
      </Grid>
    );
  }
  if (
    !moduleData &&
    (equimpLevel || drugLevel || referralLevel || reportAccess)
  ) {
    return (
      <>
        <OptionsSidebar
          href="/"
          onClick={() => setSelect(0)}
          select={select === 0}
          text="داشبورد"
          icon={<DashboardIcon color={"white"} />}
        />
        {drugLevel && (
          <OptionsSidebar
            href="/drugWarehouse"
            onClick={() => setSelect(300)}
            select={select === 300}
            text="داروخانه"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-pharmacy"}
                color={"white"}
                fontSize="20px"
              />
            }
          />
        )}
        {equimpLevel && (
          <OptionsSidebar
            href="/equipmentWarehouse"
            onClick={() => setSelect(201)}
            select={select === 201}
            text="انبار تجهیزات"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-warehouse-1-1"}
                color={"white"}
                fontSize="20px"
              />
            }
          />
        )}
        {referralLevel && (
          <OptionsSidebar
            href="/erjaTable"
            onClick={() => setSelect(220)}
            select={select === 220}
            text="ارجاعات"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-warehouse-1-1"}
                color={"white"}
                fontSize="20px"
              />
            }
          />
        )}
        {reportAccess && (
          <OptionsSidebar
            href="/reports"
            onClick={() => setSelect(240)}
            select={select === 240}
            text="گزارشات"
            icon={
              <Box
                sx={{ fontFamily: "icomoon !important " }}
                className={"icon-warehouse-1-1"}
                color={"white"}
                fontSize="20px"
              />
            }
          />
        )}
      </>
    );
  }
}
